// {id:number, name:string}[]
export const VERSIONS = [
  {id:1, name:"Standard Tracking with Live Intent V1"},
  /*{id:3, name:"Standard Tracking"},
  {id:4, name:"Reduced Tracking"},
  {id:5, name:"Extended Tracking (Including document click tracking)"},
  {id:7, name:"Standard Tracking with variable pass-through from querystring"},
  {id:8, name:"Standard Tracking with Webeo (v.1)"},
  {id:9, name:"Standard Tracking via PNG"},
  {id:10, name:"Standard Tracking with LeadAccelerate No lfuuid cookie"},
  {id:11, name:"Standard Tracking with Webeo for self-hosted clients"},
  {id:12, name:"Standard Tracking with Webeo (v.2) with cookies"},
  {id:13, name:"Standard Tracking with Tracking Cookie (lfuuid)"},
  {id:14, name:"Standard Tracking with Webeo (v.2) with cookies and mask"},
  {id:15, name:"Standard Tracking with Webeo (v.2) and Tracking Cookie"},*/
  {id:16, name:"Standard Tracking with Live Intent and Get Tracking Cookie (lfuuid) only"},
  //{id:17, name:"Set Tracking Cookie (lfuuid) only"},
  //{id:18, name:"Standard Tracking with Tracking Cookie (lfuuid) and LiveRamp"},
  {id:19, name:"Whizeo V1"},
  //{id:20, name:"Standard Tracking with Tracking Cookie and Additional Data Capture"},
  //{id:21, name:"Standard Tracking with Live Intent V1"},
  {id:22, name:"Standard Tracking with Webeo (v.3) and Tracking Cookie - Transpiled"},
  //{id:23, name:"[Devs] Standard Tracking with Webeo (v.3) and Tracking Cookie - Transpiled"},
  //{id:24, name:"Standard Tracking and Get Tracking Cookie (lfuuid) only - WITHOUT Live Intent"},
  {id:25, name:"Standard Tracking with Live Intent, SOVRN, and Get Tracking Cookie (lfuuid) only"},
  /*{id:26, name:"Standard Tracking with LiveIntent and Whizeo v2"},
  {id:27, name:"Standard Tracking with Whizeo v2"},
  {id:28, name:"Standard Tracking with Whizeo v3"},*/
  {id:29, name:"Standard Tracking with Whizeo and Webeo"},
  // {id:35, name:"Standard Tracking with Live Intent, SOVRN, and Get Tracking Cookie (lfuuid) and Pubwise"},
  {id: 40, name: "Chat"},
  {id:41, name:"Standard Tracking with New Chat and Webeo [DO NOT USE WITHOUT DEV TEAM AUTHORITY]"},
  {id:42, name:"Standard Tracking with New Chat and Whizeo [DO NOT USE WITHOUT DEV TEAM AUTHORITY]"},
  {id:43, name:"Standard Tracking with New Chat and Whizeo and Webeo [DO NOT USE WITHOUT DEV TEAM AUTHORITY]"},
  {id:119, name:"Boost + Whizeo"},
  {id:122, name:"Boost + Webeo"},
  {id:129, name:"Boost + Webeo + Whizeo"},
  {id: 140, name: "Boost + Chat"},
  {id: 141, name: "Boost + Chat + Webeo"},
  {id: 142, name: "Boost + Chat + Whizeo"},
  {id: 143, name: "Boost + Chat + Whizeo + Webeo"},
  // {id:200, name:"Standard Tracking with SOVRN Trial"},
  {id:203, name:"Standard Tracking with New Chat [DO NOT USE WITHOUT DEV TEAM AUTHORITY]"}
  //{id:216, name:"Legacy Standard Tracking with Get Tracking Cookie (lfuuid) only"}
]
